import React, { useState, useEffect } from "react";
import Snowfall from "react-snowfall";

const ChristmasOverlay = () => {
  const [isChristmas, setIsChristmas] = useState(false);

  useEffect(() => {
    // Check if today is Christmas (December 25th) based on user's local time
    const checkIfChristmas = () => {
      const today = new Date();
      const month = today.getMonth(); // 0-based, so December is 11
      const day = today.getDate();

      // Check if it's December 25th
      if (month === 11 && day === 25) {
        setIsChristmas(true);
      } else {
        setIsChristmas(false);
      }
    };

    // Check immediately when component mounts
    checkIfChristmas();

    // Set up a timer to check every hour (in case user is online during midnight transition)
    const interval = setInterval(checkIfChristmas, 3600000); // 1 hour in milliseconds

    return () => clearInterval(interval);
  }, []);

  if (!isChristmas) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none", // Allow clicks to pass through
        zIndex: 9999999999, // Extremely high z-index as requested
      }}
    >
      <Snowfall
        snowflakeCount={200}
        style={{
          position: "fixed",
          width: "100vw",
          height: "100vh",
        }}
      />
    </div>
  );
};

export default ChristmasOverlay;
